export enum InvitationStatus {
    Pending = "Pending",
    Accepted = "Accepted",
    Declined = "Declined",
}